<template>
  <Swiper
    ref="swiper-image"
    key="swiper-image"
    :slides-per-view="1"
    :modules="swiper.modules"
    :pagination="swiper.pagination"
    :loop="voyages.length > 1"
    class="swiper-image swiper2"
  >
    <SwiperSlide
      v-for="(item, key) in voyages"
      :key="`img-${key}`"
      class="swiper-image__image"
      @click="
        $router.push({
          name: 'voyage',
          params: { slug: item.slug },
        })
      "
      :style="{
        backgroundImage: `url(${item.cover_id?.lg || 'https://placehold.co/1920x1080'})`,
      }"
    >
      <div class="swiper-image__content">
        <div>
          <Icon id="destination" class="header__card-destination" />

          {{ item.name }}
        </div>

        <div>
          {{ item.identifier }}
        </div>

        <div>
          <Icon id="arrow" />
        </div>
      </div>
    </SwiperSlide>

    <SectionSwiperControls :items-count="voyages.length" always-show />
  </Swiper>
</template>

<script>
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import SectionSwiperControls from '@/components/blocks/SectionSwiperControls.vue'
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'SectionSwiperImage',

  components: {
    Icon,
    SectionSwiperControls,
    Swiper,
    SwiperSlide,
  },

  props: {
    destinations: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    voyages() {
      return Object.values(this.$beet.destinations).filter(({ id }) =>
        this.destinations.includes(String(id)),
      )
    },
  },

  data() {
    return {
      swiper: {
        modules: [Pagination],
        slideToClickedSlide: true,
        grabCursor: true,

        pagination: {
          clickable: true,
          horizontalClass: 'swipe-horizontal__higher',
          bulletClass: 'swipe-bullet -blue',
          bulletActiveClass: 'swipe-bullet-active',
        },
      },
    }
  },
}
</script>
